import React from "react";
import { refinementFeedbackView, refinementFeedbackField, refinementFeedbackSections } from "./triproutes-refinements.mjs";

export function ModeratorFeedback({feedback, issues}) {
 const view=refinementFeedbackView(feedback,issues);
 return <>{view.summary&&<p className="triproutes-moderator-feedback">{view.summary}</p>}{view.issues.length>0&&<ul>{view.issues.map((issue,i)=><li key={i}>{issue.pointId&&`${issue.field?.startsWith("city.")?"Поле":"Точка"} #${issue.pointId} · `}{refinementFeedbackField(issue.field)} · {issue.comment}</li>)}</ul>}</>;
}

export function RefinementFeedbackSections({feedback, issues}) {
 const {review, automatic} = refinementFeedbackSections(feedback, issues);
 return <section className="triproutes-job-details" aria-label="Замечания модератора">
  <h4>Замечания модератора</h4>
  {review.feedback || review.issues.length ? <ModeratorFeedback {...review}/> : <p>Нет замечаний.</p>}
  {(automatic.feedback || automatic.issues.length > 0) && <details><summary>Автоматические проверки · Агент 4 и география</summary><ModeratorFeedback {...automatic}/></details>}
 </section>;
}

export function RefinementRouteFeedback({route}) {
 return <div><RefinementFeedbackSections feedback={route.humanFeedback} issues={route.humanFeedbackIssues}/><p className="muted">При запуске замечания и проблемы по точкам автоматически загружаются из TripRoutes. Ниже можно добавить указания для этого запуска.</p></div>;
}
